import {Typography} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid';
import {ReactComponent as InfoIcon} from '../../assets/images/info-icon.svg';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';
import {convertToUTCDate} from '../../utils/formatters';
import ArrTooltipWrapper from '../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';

export const manageCodingFormsColumns = (): GridColDef[] => [
  {
    field: 'codingFormName',
    headerName: t('codingForms.grid.codingFormName'),
    headerClassName: 'typo-text label2_size',
    flex: 1,
  },
  {
    field: 'userCreatedBy',
    headerName: t('codingForms.grid.userCreatedBy'),
    headerClassName: 'typo-text label2_size',
    flex: 1,
  },
  {
    field: 'userCreatedDate',
    headerName: t('codingForms.grid.userCreatedDate'),
    flex: 1,
    renderCell: (params) => {
      const dateValue = convertToUTCDate(params.row.userCreatedDate);
      return (
        <span
          title={dateValue}
          data-testid={`coding-forms-created-date-${params.id}`}
        >
          {dateValue}
        </span>
      );
    },
  },
  {
    field: 'isUsedInAssignment',
    flex: 1,
    sortable: false,
    headerName: t('codingForms.grid.isUsedInAssignment'),
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`coding-forms-utils-is-used-in-assignment`}
          >
            {t('codingForms.grid.isUsedInAssignment')}
          </Typography>
          <ArrTooltipWrapper
            title={t('codingForms.grid.isUsedInAssignment')}
            trigger={
              <InfoIcon fontSize="small" className="coding-form-info-icon" />
            }
          >
            {t('codingForms.grid.isUsedInAssignmentInfo')}
          </ArrTooltipWrapper>
        </>
      );
    },
  },
  {
    field: 'securityGroupForm',
    flex: 1,
    sortable: false,
    headerName: t('codingForms.grid.securityGroupForm'),
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`coding-forms-utils-security-group-form`}
          >
            {t('codingForms.grid.securityGroupForm')}
          </Typography>
          <ArrTooltipWrapper
            title={t('codingForms.grid.securityGroupForm')}
            trigger={
              <InfoIcon fontSize="small" className="coding-form-info-icon" />
            }
          >
            {t('codingForms.grid.securityGroupFormInfo')}
          </ArrTooltipWrapper>
        </>
      );
    },
  },
];

export const codingFormsDetailsMoreMenu = (): CustomMenuItem[] => [
  {label: 'Edit', id: 'edit'},
  {label: 'Copy', id: 'copy'},
  {label: 'Delete', id: 'delete'},
];
